// extracted by mini-css-extract-plugin
export var details = "_ea-0";
export var inspectorPopover = "_ea-1";